import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Dashboard } from "./components/organisms/Dashboard";
import { STYLES } from "./config/styles";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className={`min-h-screen bg-[#E8F0EC] ${STYLES.spacing.page}`}>
        <div className={`${STYLES.container.maxWidth} mx-auto`}>
          <Dashboard showHeader={true} />
        </div>
      </div>
    </QueryClientProvider>
  );
}

export default App;
